import { ReactNode } from "react";
import { CircleHelp } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "~/components/ui/tooltip";

/**
 * A caveat a short label cannot state, offered on hover. `label` names the
 * trigger, so it is reachable by name rather than as "help".
 */
export const HintTooltip = ({ label, children }: { label: string; children: string }) => (
  <Tooltip delayDuration={200}>
    <TooltipTrigger
      className="cursor-help text-muted-foreground hover:text-foreground"
      aria-label={`About ${label}`}
    >
      <CircleHelp className="size-3.5" aria-hidden />
    </TooltipTrigger>
    <TooltipContent side="top" className="max-w-xs font-normal">
      {children}
    </TooltipContent>
  </Tooltip>
);

/**
 * A heading with its hint last.
 *
 * Args:
 *   label: The heading text, and the hint trigger's name.
 *   hint: Without one the heading renders bare.
 *   children: Replaces the label text, for a heading that is also a control.
 */
export const HintedHead = ({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children?: ReactNode;
}) => (
  <span className="inline-flex items-center gap-1">
    {children ?? label}
    {hint && <HintTooltip label={label}>{hint}</HintTooltip>}
  </span>
);
